import React from "react";
import { observer } from "mobx-react";
import Calendar from "./Calendar";
import { useSingleTherapistCalendarController } from "./controller/SingleTherapistCalendarController";

/**
 * SingleTherapistCalendarWithController
 *
 * Wrapper component for the single-therapist weekly view.
 * Shows a ±7 day range of appointments for the selected therapist.
 */
const SingleTherapistCalendarWithController: React.FC = observer(() => {
  const controller = useSingleTherapistCalendarController();

  if (!controller) {
    return <div>Loading...</div>;
  }
  const { data, handlers } = controller;

  return (
    <>
      <Calendar
        calendarEvents={data.calendarEvents}
        selectedShelfAppointment={data.selectedShelfAppointment}
        patientAvailabilities={data.patientAvailabilities}
        patientUnavailableTypes={data.patientUnavailableTypes}
        users={data.users}
        resources={data.resources}
        date={data.selectedDate}
        isContinuous={false}
        isLoading={data.isLoading}
        lockedAppointments={data.lockedAppointments}
        sublocalities={data.sublocalities}
        headerWidth={data.headerWidth}
        onDatesSet={handlers.onDatesSet}
        onReachWindowStart={handlers.onReachWindowStart}
        onReachWindowEnd={handlers.onReachWindowEnd}
        onCreateEvent={handlers.onCreateEvent}
        onChangeEvent={handlers.onChangeEvent as any}
        onEventReceive={handlers.onEventReceive}
        onRemoveEvent={handlers.onRemoveEvent}
        onRemoveGroupTherapist={handlers.onRemoveGroupTherapist}
        onRemoveContinuousEvent={handlers.onRemoveContinuousEvent}
        onOutdated={handlers.onOutdated}
        onContinuousViewChange={handlers.onContinuousViewChange}
        onCancelledViewChange={handlers.onCancelledViewChange}
        onMoveEventDate={handlers.onMoveEventDate as any}
        onAddShelfEvent={handlers.onAddShelfEvent as any}
        onEventContentClick={handlers.onEventContentClick}
        onCloseNotesDialog={handlers.onCloseNotesDialog}
        onSelectedShelfEventReceive={handlers.onSelectedShelfEventReceive}
        groupCheck={data.groupCheck}
        cellSelection={data.focusPosition || undefined}
      />
    </>
  );
});
SingleTherapistCalendarWithController.displayName = "SingleTherapistCalendarWithController";
export default SingleTherapistCalendarWithController;
